import React, {useCallback, useState} from 'react';

import {useFocusEffect, useRoute} from '@react-navigation/native';
import {rastrear} from '../../services/rastrear';
import bannerVr from '../../assets/images/vr.webp';

import {RootStackParamList} from '../../dtos/RoutesDTO';

import {CheckoutSession} from '../../components/shared/Payments/CheckoutSession';
import {Core} from '../../components/shared/Payments/CheckoutSession/modules/Core';
import {ValeModal} from '../../components/shared/ValeModal';
import {useAuth} from '../../context/auth';

export function Payment() {
  const route = useRoute();
  const {clientId} = useAuth();

  const {
    pedidos,
    localidade,
    gnv,
    discount,
    coupon,
    loading,
    posto,
    stationsByProductId,
  } = route.params as RootStackParamList['PaymentNovo'];

  const [showModalVale, setShowModalVale] = useState(false);

  useFocusEffect(
    useCallback(() => {
      rastrear({status_tela: 'checkout', cidade: localidade.cidade});
    }, [localidade.cidade]),
  );

  const banners = [
    {
      id: '1',
      imageUrl: bannerVr,
      action: () => {
        setShowModalVale(true);
      },
    },
  ];


  return (
    <>
      <CheckoutSession
        paymentMethodItemFooterBanners={banners}
        enableCCT={clientId !== 'barataoweb'}
        enablePendingPayment={false}
        module={
          <Core
            localidade={localidade}
            pedidos={pedidos}
            coupon={coupon}
            discount={discount}
            gnv={gnv}
            loading={loading}
            stationsByProductId={stationsByProductId}
            posto={posto}
          />
        }
      />
      <ValeModal
        showModal={showModalVale}
        onDismiss={() => setShowModalVale(false)}
      />
    </>
  );
}
